// API version
export const V1 = 'v1'

// API end point
export const HOST_ENDPOINT =
  process.env.REACT_APP_API_END_POINT || 'https://beta-apione.medz91.com/nada'
